<template>
  <span
    :style="{
      padding: '3px 8px',
      backgroundColor: statusStyle.background,
      color: statusStyle.color,
      border: borderStyle,
      borderRadius: '10px',
      fontWeight: '700',
      fontSize: '14px',
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
      display: 'inline-block',
      width: 'fit-content',
      lineHeight: '1.5',
    }"
    :class="$attrs.class"
  >
    <slot>
      {{ label }}
    </slot>
  </span>
</template>

<script>

export default {
  props: {
    type: { type: String, required: true },
    status: { type: String, required: true },
  },
  computed: {
    statusStyle() {
      const map = {
        cases: {
          open: { background: '#EDF4FE', color: '#007BFF' },
          pending: { background: '#FFF2E0', color: '#FA9917' },
          closed: { background: '#E5FFEC', color: '#3DA568' },
          archived: { background: '#F4F4F4', color: '#848484' },
          unbilled: { background: '#FFEDED', color: '#D84F4F' },
        },
        clients: {
          active: { background: '#EDF4FE', color: '#007BFF' },
          archived: { background: '#F4F4F4', color: '#848484' },
          merged: { background: '#848484', color: '#FFFFFF' },
          passive: { background: '#F4F4F4', color: '#848484' },
          invited: { background: '#FFF2E0', color: '#FA9917' },
          inactive: { background: '#FFEDED', color: '#D84F4F' },
        },
        tickets: {
          open: { background: '#EDF4FE', color: '#007BFF' },
          converted: { background: '#E5FFEC', color: '#3DA568' },
          autofilled: { background: '#E5FFEC', color: '#3DA568' },
          archived: { background: '#F4F4F4', color: '#848484' },
        },
        tasks: {
          active: { background: '#EDF4FE', color: '#007BFF' },
          incomplete: { background: '#EDF4FE', color: '#007BFF' },
          inactive: { background: '#F4F4F4', color: '#848484' },
          claimed: { background: '#848484', color: '#FFFFFF' },
          if_applicable: { background: '#FFFFFF', color: '#848484' },
          not_applicable: { background: '#F4F4F4', color: '#848484' },
          completed: { background: '#E5FFEC', color: '#3DA568' },
        },
        homework: {
          assigned: { background: '#EDF4FE', color: '#007BFF' },
          pending: { background: '#FFF2E0', color: '#FA9917' },
          verified: { background: '#E5FFEC', color: '#3DA568' },
        },
        forms: {
          new_edition_available: { background: '#FFF2E0', color: '#FA9917' },
          new_edition_available_and_expired: { background: '#FFF2E0', color: '#FA9917' },
          expired: { background: '#FFEDED', color: '#D84F4F' },
          archived: { background: '#F4F4F4', color: '#848484' },
        },
        priority_dates: {
          eligible: { background: '#EDF4FE', color: '#007BFF' },
          ineligible: { background: '#FFEDED', color: '#D84F4F' },
          filed: { background: '#E5FFEC', color: '#3DA568' },
          unfiled: { background: '#F4F4F4', color: '#848484' },
        },
        invoices: {
          open: { background: '#EDF4FE', color: '#007BFF' },
          paid: { background: '#E5FFEC', color: '#3DA568' },
          overdue: { background: '#FFEDED', color: '#D84F4F' },
        },
        payments: {
          paid: { background: '#E5FFEC', color: '#3DA568' },
          pending: { background: '#FFF2E0', color: '#FA9917' },
          failed: { background: '#FFEDED', color: '#D84F4F' },
        },
        sequential_task: {
          late: { background: '#FFEDED', color: '#D84F4F' },
          left: { background: '#FFF2E0', color: '#FA9917' },
        },
        procedures: {
          active: { background: '#EDF4FE', color: '#007BFF' },
          archived: { background: '#F4F4F4', color: '#848484' },
        },
        signature: {
          pending: { background: '#FFFDCA', color: '#CEB303' },
          sending: { background: '#FFFDCA', color: '#CEB303' },
          sent: { background: '#EDF4FE', color: '#007BFF' },
          completed: { background: '#E5FFEC', color: '#3DA568' },
          voided: { background: '#FFEDED', color: '#D84F4F' },
          declined: { background: '#FFDAC7', color: '#5A2D02' },
          disconnected: { background: '#F4F4F4', color: '#848484' },
        },
      };

      return (
        map[this.type]?.[this.status] ?? {
          background: '#eee',
          color: '#333',
        }
      );
    },
    borderStyle() {
      if (this.type === 'tasks' && this.status === 'if_applicable') {
        return '1px dashed #848484';
      } else if (this.statusStyle.border) {
        return `1px solid ${this.statusStyle.border}`;
      } else {
        return 'none';
      }
    },
    label() {
      return this.status
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (l) => l.toUpperCase());
    },
  },
};
</script>
